import { makeStyles } from '@material-ui/core'
import React from 'react'

const REGISTERED_MARK = '®'

const useStyles = makeStyles(() => ({
  // GR-10752: brand asks for a small ® raised above the baseline, not the font's full-size glyph.
  // lineHeight 0 keeps the superscript from pushing the line box taller.
  mark: {
    fontSize: '0.65em',
    lineHeight: 0,
    verticalAlign: 'super',
    marginLeft: '0.05em'
  }
}))

/**
 * Renders a translated product name, turning every ® into a small superscript.
 * Keep the name itself a plain string (alt texts, keys) and wrap it only where it is displayed.
 */
const TrademarkText = ({ text }) => {
  const classes = useStyles()

  if (typeof text !== 'string' || !text.includes(REGISTERED_MARK)) {
    return text ?? null
  }

  // One wrapper, so a flex parent gets a single item: separate items would blockify the <sup> and lose
  // vertical-align, and the parent's gap would push the ® away from the name.
  return (
    <span>
      {text.split(REGISTERED_MARK).map((part, index) => (
        <React.Fragment key={index}>
          {index > 0 && <sup className={classes.mark}>{REGISTERED_MARK}</sup>}
          {part}
        </React.Fragment>
      ))}
    </span>
  )
}

export default TrademarkText
